module.exports = __webpack_public_path__ + "static/media/NotoSansKR-Light-Alphabetic.5465aff2.woff2";